import SelectField from "../common/SelectField.js"

/** Compact per-branch agent picker for Admin/Accountant bulk receive (hub PK grouped). */
export default function HubAgentPickPanel({
  groups,
  hubAgentPick,
  onSelectAgent,
  compactSelect = true,
}) {
  if (!groups?.length) return null

  return (
    <div className="mb-2 sm:mb-3 px-2 py-1.5 sm:px-2.5 sm:py-2 bg-violet-50 rounded-lg border border-violet-200">
      <p className="text-[10px] sm:text-[11px] font-semibold text-violet-900 mb-1">
        Receiver agents · {groups.length} branch{groups.length === 1 ? "" : "es"}
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-1 sm:gap-1.5">
        {groups.map((group) => {
          const pick = hubAgentPick[group.hubId] || {}
          const agents = pick.agents || []
          const count = group.shipments?.length || pick.count || 0
          return (
            <div
              key={group.hubId}
              className="rounded-md border border-violet-100 bg-white px-2 py-1.5"
            >
              <p className="text-[10px] sm:text-xs font-medium text-gray-800 truncate">
                {group.label} · {count} GC{count === 1 ? "" : "s"}
              </p>
              {pick.loading ? (
                <p className="text-[10px] text-gray-500 mt-0.5">Loading agents…</p>
              ) : agents.length === 0 ? (
                <p className="text-[10px] text-red-600 mt-0.5">No agent at this branch</p>
              ) : agents.length === 1 ? (
                <p className="text-[10px] text-gray-700 mt-0.5">{agents[0].name}</p>
              ) : (
                <SelectField
                  variant="form"
                  compact={compactSelect}
                  value={pick.selectedUserId || ""}
                  onChange={(e) => onSelectAgent(group.hubId, e.target.value)}
                  className="mt-0.5 w-full text-[10px] sm:text-xs"
                >
                  <option value="">Select agent…</option>
                  {agents.map((agent) => (
                    <option key={agent.user_id} value={agent.user_id}>
                      {agent.name}
                    </option>
                  ))}
                </SelectField>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}
